<template>
  <v-card class="pa-10">
    <v-form v-model="valid">
      <v-row>
        <v-col lg="6" md="6">
          <v-text-field rounded outlined label="Title" v-model="title" :rules="nameRules" required></v-text-field>
          <v-text-field
            rounded
            outlined
            label="Sub Title"
            v-model="subTile"
            :rules="subTitleRules"
            required
          ></v-text-field>
          <v-autocomplete
            v-model="action"
            :items="type_item"
            item-text="type_name"
            item-value="id"
            rounded
            outlined
            placeholder="Please Choose the Type Banner"
            :rules="sectionRules"
          ></v-autocomplete>
          <v-textarea outlined name="input-7-4" label="Decription"></v-textarea>
        </v-col>
        <v-col lg="6" md="6">
          <v-file-input
            :rules="fileRules"
            accept="image/png, image/jpeg, image/bmp"
            v-model="imageFiles"
            v-on:change="processFile"
            prepend-icon="mdi-camera"
            label="เลือกรูปภาพ"
            class="p-absolute center-row full-width"
            outlined
            rounded
            dense
            show-size
          ></v-file-input>
          <p class="mb-0">ตัวอย่างรูป Banner</p>
          <v-card class="mt-5" :color="`grey lighten-2`" elevation="3">
            <v-img
              :src="imgPreview == null ? imageReady : imgPreview"
              :lazy-src="imgPreview"
              aspect-ratio="1"
              contain
              height="300"
            >
              <template v-slot:placeholder>
                <v-row class="fill-height ma-0" align="center" justify="center">
                  <!-- <v-progress-circular indeterminate color="grey lighten-5"></v-progress-circular> -->
                  <v-icon v-if="imageReady" class="mx-auto" elevation="3" size="100">mdi-image</v-icon>
                </v-row>
              </template>
            </v-img>
          </v-card>
        </v-col>
      </v-row>

      <div class="my-5 text-right">
        <v-btn
          rounded
          color="primary"
          dark
          :disabled="!imgPreview && !valid"
          @click="uploadBanner"
        >Submit</v-btn>
      </div>
    </v-form>
  </v-card>
</template>
<script>
import { uploadImage } from "@/service/upload/upload";
import { insertBanner } from "@/service/setting/setting";

export default {
  computed: {
    fileRules() {
      const rules = [];
      const rule = v => !!v || "กรุณาเลือกอัปโหลดรูปภาพ";
      rules.push(rule);

      const rule2 = v =>
        (v && v.size < 20000000) || "กรุณาเลือกไฟล์ที่มีขนาดน้อยกว่า 20 MB";
      rules.push(rule2);

      return rules;
    }
  },
  data() {
    return {
      type_item: [
        {
          id: "0",
          type_name: "web "
        },
        {
          id: "1",
          type_name: "mobile"
        }
      ],
      imageReady: true,
      imgPreview: "",
      imageFiles: [],
      imageUrl: "",
      nameRules: [v => !!v || "Title is required"],
      subTitleRules: [v => !!v || "Subtitle is required"],
      title:'',
      subTile:'',
      discription:''

    };
  },

  methods: {
    async processFile() {
      this.imgPreview = URL.createObjectURL(this.imageFiles);
    },
    async uploadBanner() {
      this.loadding = true;

      this.imageUrl =
        this.imageFiles.length !== 0
          ? await this.uploadImg(this.imageFiles)
          : "";

      let insertBannerStatus = await insertBanner({
        title: this.title,
        subTitle: this.subTile,
        description: this.discription,
        categories: [],
        courses: [],
        url: '',
        action: [],
        priority: 0,
        image: this.imageUrl
      });
      console.log(insertBannerStatus)
    },
    async uploadImg(image) {
      let status = await uploadImage("banner", image);
      return status;
    }
  }
};
</script>
<style scope>
.theme--dark.v-btn.v-btn--disabled:not(.v-btn--flat):not(.v-btn--text):not(.v-btn--outlined) {
  background-color: #bdbdbd !important;
}
</style>